import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';

const StatWidgetTooltip = ({ children, open, anchorEl, interactive = false }) => {
  return (
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
        sx={{ zIndex: (theme) => theme.zIndex.tooltip }}
        modifiers={[
          { name: 'offset', options: { offset: [0, 8] } },
          { name: 'preventOverflow', options: { padding: 8 } }
        ]}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={300}>
            <Paper
              elevation={8}
              // onMouseEnter={interactive ? handleOpen : undefined}
              // onMouseLeave={interactive ? handleClose : undefined}
              sx={{
                overflow: 'hidden',
                borderRadius: '12px',
                minWidth: 220,
                maxWidth: 320,
                pointerEvents: interactive ? 'auto' : 'none'
              }}
            >
              {children}
            </Paper>
          </Fade>
        )}
      </Popper>
    
  );
};

export default StatWidgetTooltip;
